module.exports = __webpack_public_path__ + "img/platform3.51cee249.png";